import {createEditor as createBlankEditor} from 'slate'
import {pipe} from '@udecode/slate-plugins'
import {withPlugins} from './plugins'

export const createEditor = () => pipe(createBlankEditor(), ...withPlugins)
